module.exports = __webpack_public_path__ + "thirdpartyteacherwpdf9bd0c6bc0f7dddca8ea8485d95a388.png";